import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';
import PageHero from '@components/PageHero';
import { DynamicComponents } from '@lib/dynamicComponents';

import { Content } from '@identity/wrappers';
import { Wrapper } from '../templates/Blog/styles';

export default ({ data }) => {
  const servicesPage = data.contentfulPage;

  const hero = data.contentfulPage.pageHero;

  return (
    <>
      <Helmet title="The Farmhouse | Services" />
      <PageHero {...hero} />

      <Content>
        <Wrapper
          space={{
            margin: {
              default: 'top-lg',
              desktop: 'top-md',
            },
          }}
        >
          {servicesPage.content.map(content => (
            <DynamicComponents {...content} key={content.id} />
          ))}
        </Wrapper>
      </Content>
    </>
  );
};

export const query = graphql`
  {
    contentfulPage(contentful_id: { eq: "5Je5hsaEMCl7CUZK76DCzM" }) {
      content {
        __typename
        ...Services
        # ...SideBySide
        # ...SectionText
      }
      pageHero {
        ...PageHero
      }
    }
  }
`;
